/**
 * Analytics Event Helpers — Meta Pixel + Google Analytics 4
 *
 * Sayify does NOT inject the Meta Pixel or GA4 scripts.
 * The form owner embeds them on their site where the Sayify form is loaded.
 * Sayify only fires events on top of the existing pixel/tag.
 */

/**
 * Fire a Meta Pixel custom event.
 * Requires fbq('init', ...) to be on the host page.
 *
 * @param {string} eventName - Meta event name (e.g. 'Lead', 'SubmitApplication')
 * @param {Object} params - Optional event parameters
 */
export const fireMetaPixelEvent = (eventName, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('trackCustom', eventName, params);
    }
  } catch (e) {
    // Silently fail — analytics should never break the UX
  }
};

/**
 * Fire a Google Analytics 4 event.
 * Requires gtag('config', ...) to be on the host page.
 *
 * @param {string} eventName - GA4 event name (e.g. 'generate_lead', 'sign_up')
 * @param {Object} params - Optional event parameters
 */
export const fireGA4Event = (eventName, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  } catch (e) {
    // Silently fail — analytics should never break the UX
  }
};

/**
 * Fire all configured analytics events for a conditional TY outcome.
 *
 * @param {Object} outcome - The matched TY outcome with optional meta_event/ga_event fields
 */
export const fireOutcomeAnalytics = (outcome) => {
  if (!outcome) return;

  if (outcome.meta_event) {
    fireMetaPixelEvent(outcome.meta_event, outcome.meta_event_params || {});
  }

  if (outcome.ga_event) {
    fireGA4Event(outcome.ga_event, outcome.ga_event_params || {});
  }
};
